if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        // Reset any error/disabled state when user changes options or quantity
        try {
          this.form.addEventListener('change', () => this.clearErrorState());
          document.addEventListener('puredeal:closed', () => this.clearErrorState());
        } catch(e) {}
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        // Normalize payload for Shopify AJAX endpoint
        try {
          ['product-id','section-id','utf8','form_type'].forEach((k)=>{ if (formData.has(k)) formData.delete(k); });
        } catch(e) {}
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // Pre-check inventory to avoid 422 and show clear message in popup
        try {
          const variantId = formData.get('id');
          const qtyToAdd = parseInt(formData.get('quantity') || '1', 10) || 1;
          const handleFromUrl = (window.location.pathname.match(/\/products\/([^\/]+)/)||[])[1];
          if (variantId && handleFromUrl){
            const prod = await fetch(`/products/${handleFromUrl}.js`).then(r=>r.json()).catch(()=>null);
            const v = prod && Array.isArray(prod.variants) ? prod.variants.find(x=>String(x.id)===String(variantId)) : null;
            // Determine if this product participates in a deal (used to decide showing popup)
            try {
              const tags = Array.isArray(prod && prod.tags) ? prod.tags.map(t=>String(t||'').replace(/\s+/g,'_').toUpperCase()) : [];
              const comboOrDealKeys = ['FREE_TEE_WOMEN','FREE_TEE_MEN','WOMEN_JEAN_DEAL','MEN_JEAN_DEAL','GOWN_DEAL','20_SLIPPER_DEAL'];
              this._pdIsDeal = tags.some(t => /DEAL/.test(t)) || tags.some(t => comboOrDealKeys.indexOf(t) > -1);
            } catch(e) { this._pdIsDeal = false; }
            if (v){
              // If not available at all
              if (v.available === false){
                const msg = `The product '${v.name||prod.title||''}' is already sold out.`;
                this.handleErrorMessage(msg);
                try {
                  var PD = (typeof window !== 'undefined' && window.PureDeal) ? window.PureDeal : (typeof PureDeal !== 'undefined' ? PureDeal : null);
                  if (PD && typeof PD.showError === 'function') { PD.showError(msg || 'There was a problem adding this item. Please try again.'); }
                } catch(e) {}
                this.submitButton.classList.remove('loading');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                this.querySelector('.loading__spinner').classList.add('hidden');
                return;
              }
              const invQty = (typeof v.inventory_quantity === 'number' ? v.inventory_quantity : null);
              const policy = v.inventory_policy || 'deny';
              // If Shopify does not expose inventory_quantity (e.g., preorder/continue or no tracking), skip quantity precheck
              if (invQty !== null && policy !== 'continue'){
                const cart = await fetch('/cart.js').then(r=>r.json()).catch(()=>({items:[]}));
                const inCart = (cart.items||[]).find(it=>String(it.id)===String(variantId));
                const currentQty = inCart ? (inCart.quantity||0) : 0;
                const desired = currentQty + qtyToAdd;
                if (desired > invQty){
                  const remaining = Math.max(invQty - currentQty, 0);
                  const msg = remaining > 0
                    ? `Only ${remaining} left in stock for this size.`
                    : `This item is sold out for the selected size.`;
                  this.handleErrorMessage(msg);
                  try {
                    var PD2 = (typeof window !== 'undefined' && window.PureDeal) ? window.PureDeal : (typeof PureDeal !== 'undefined' ? PureDeal : null);
                    if (PD2 && typeof PD2.showError === 'function') { PD2.showError(msg || 'There was a problem adding this item. Please try again.'); }
                  } catch(e) {}
                  this.submitButton.classList.remove('loading');
                  if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                  this.querySelector('.loading__spinner').classList.add('hidden');
                  return;
                }
                // Save snapshot for later error friendliness (in case server rejects increment)
                try { this._pdInvQty = invQty; this._pdCurrentQty = currentQty; this._pdVariantId = variantId; } catch(e) {}
              }
              // If inventory_quantity is not available, rely on add.js error handling (already wired to show in popup)
            }
          }
        } catch(e) { /* ignore precheck failures */ }

        // Ensure we always use the AJAX endpoint
        const addUrl = (routes.cart_add_url || '/cart/add').replace(/\/cart\/add(?:\.js)?$/, '/cart/add.js');

        const variantId = formData.get('id');
        let prevQtyForIncrement = null;
        const sections = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];

        const doAdd = () => fetch(addUrl, config).then((response) => response.json());

        const doIncrement = (idx, currentQty) => {
          const body = JSON.stringify({
            line: idx + 1,
            quantity: (currentQty || 0) + 1,
            sections: sections,
            sections_url: window.location.pathname,
          });
          return fetch(`${routes.cart_change_url}`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body }).then((r)=>r.json());
        };

        const promise = fetch('/cart.js', { headers: { 'Accept': 'application/json' }})
          .then(r=>r.json())
          .then(cart => {
            const items = Array.isArray(cart.items) ? cart.items : [];
            const idx = items.findIndex(it => String(it.id) === String(variantId));
            if (idx > -1) {
              try { prevQtyForIncrement = items[idx].quantity; } catch(e) { prevQtyForIncrement = null; }
              return doIncrement(idx, items[idx].quantity);
            }
            return doAdd();
          })
          .catch(()=> doAdd());

        promise
          .then((response) => {
            if (response.status || response.errors) {
              const errorMsg = response.errors || response.description || response.message || 'Unable to add to cart.';
              // If we have precheck data, emit a clearer message for max qty
              try {
                if (typeof this._pdInvQty === 'number' && typeof this._pdCurrentQty === 'number') {
                  const remaining = Math.max(this._pdInvQty - this._pdCurrentQty, 0);
                  if (remaining >= 0) {
                    const niceMsg = remaining > 0
                      ? `Only ${remaining} left in stock for this size.`
                      : `This item is sold out for the selected size.`;
                    if (!/Only \d+ left|sold out/i.test(String(errorMsg))) {
                      try { var PDx = (window && window.PureDeal) ? window.PureDeal : null; if (PDx && PDx.showError) PDx.showError(niceMsg); } catch(e) {}
                    }
                  }
                }
              } catch(e) {}
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: errorMsg,
                message: errorMsg,
              });
              this.handleErrorMessage(errorMsg);
              try {
                var PD3 = (typeof window !== 'undefined' && window.PureDeal) ? window.PureDeal : (typeof PureDeal !== 'undefined' ? PureDeal : null);
                if (PD3 && typeof PD3.showError === 'function') { PD3.showError(errorMsg || 'There was a problem adding this item. Please try again.'); }
              } catch(e) {}
              // Avoid dispatching an additional global event since we already showed the popup error above.
              // Dispatching here would cause duplicate notices in the popup.

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else {
              // Guard: if we attempted an increment but quantity didn't change, show a friendly limit message
              if (prevQtyForIncrement !== null) {
                return fetch('/cart.js', { headers: { 'Accept': 'application/json' }})
                  .then(r=>r.json())
                  .then(newCart => {
                    try {
                      const nItems = Array.isArray(newCart.items) ? newCart.items : [];
                      const it = nItems.find(it => String(it.id) === String(variantId));
                      const newQty = it ? (it.quantity||0) : 0;
                      if (newQty <= prevQtyForIncrement) {
                        let shouldShowLimit = false;
                        try {
                          if (typeof this._pdInvQty === 'number' && typeof this._pdCurrentQty === 'number') {
                            const remainingAtAdd = Math.max(this._pdInvQty - this._pdCurrentQty, 0);
                            shouldShowLimit = remainingAtAdd === 0;
                          }
                        } catch(e) {}
                        if (shouldShowLimit) {
                          const limitMsg = 'You\u2019ve reached the maximum quantity available for this size.';
                          this.handleErrorMessage(limitMsg);
                          try { var PDlim = (window && window.PureDeal) ? window.PureDeal : null; if (PDlim && PDlim.showError) PDlim.showError(limitMsg); } catch(e) {}
                          this.error = true;
                          throw '__PD_MAX_REACHED__';
                        }
                        return response;
                      }
                    } catch(e) {}
                    return response;
                  })
                  .then((resp) => {
                    // Always open PureDeal popup on successful add/increment (no error)
                    try {
                      if (!this.error && this._pdIsDeal) {
                        const handleFromUrl = (window.location.pathname.match(/\/products\/([^\/]+)/)||[])[1];
                        if (typeof PureDeal !== 'undefined' && typeof PureDeal.open === 'function') {
                          PureDeal.open({ handle: handleFromUrl });
                        }
                      }
                    } catch(e) {}
                    if (!this.cart) {
                      if (!this.error)
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                          source: 'product-form',
                          productVariantId: formData.get('id'),
                          cartData: resp,
                        });
                      return resp;
                    }
                    if (!this.error)
                      publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'product-form',
                        productVariantId: formData.get('id'),
                        cartData: resp,
                      });
                    this.error = false;
                    const quickAddModal = this.closest('quick-add-modal');
                    if (quickAddModal) {
                      document.body.addEventListener(
                        'modalClosed',
                        () => {
                          setTimeout(() => {
                            this.cart.renderContents(resp);
                          });
                        },
                        { once: true }
                      );
                      quickAddModal.hide(true);
                    } else {
                      this.cart.renderContents(resp);
                    }
                    return resp;
                  });
              }
            }

            // Always open PureDeal popup on successful add/increment (no error)
            try {
              if (!this.error && this._pdIsDeal) {
                const handleFromUrl = (window.location.pathname.match(/\/products\/([^\/]+)/)||[])[1];
                if (typeof PureDeal !== 'undefined' && typeof PureDeal.open === 'function') {
                  PureDeal.open({ handle: handleFromUrl });
                }
              }
            } catch(e) {}

            if (!this.cart) {
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            if (e === '__PD_MAX_REACHED__') {
              // Already handled with friendly message
            } else {
              console.error(e);
              try {
                var PD4 = (typeof window !== 'undefined' && window.PureDeal) ? window.PureDeal : (typeof PureDeal !== 'undefined' ? PureDeal : null);
                if (PD4 && typeof PD4.showError === 'function') { PD4.showError('Unable to add to cart. This item may be sold out.'); }
              } catch(err) {}
            }
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      clearErrorState() {
        try {
          this.error = false;
          if (this.submitButton) {
            this.submitButton.removeAttribute('aria-disabled');
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) soldOutMessage.classList.add('hidden');
            const primarySpan = this.submitButton.querySelector('span');
            if (primarySpan) primarySpan.classList.remove('hidden');
          }
          // Clear inline error text under the button
          this.handleErrorMessage(false);
        } catch(e) {}
      }
    }
  );
}
